export default __webpack_public_path__ + "static/media/11.5016d4dc.png";